import React from "react";
import PropTypes from "prop-types";
import style from "../../stylesheets/StoreFilter.module.scss";
import mobileStyle from "../../stylesheets/MobileFilter.module.scss";
import { PRICE_PSEUDO_FACET_ID } from "../../constants";

const PriceFilter = ({
  maxPrice,
  minPrice,
  min_price_input,
  max_price_input,
  selectedDropdown,
  showDropdown,
  handlePriceFilterClick,
  handlePriceFilterInput,
  isMobile,
  clearPriceFilter,
}) => {
  const handleSetPrice = (e) => {
    e.preventDefault();
    handlePriceFilterClick();
  };

  const handleChange = (e) => {
    let min;
    let max;

    if (e.target.id === "minPriceValue") {
      min = e.target.value;
      max = document.querySelector("#maxPriceValue").value;
    } else if (e.target.id === "maxPriceValue") {
      min = document.querySelector("#minPriceValue").value;
      max = e.target.value;
    }

    handlePriceFilterInput(min, max);
  };

  const handleClearPrice = () => {
    clearPriceFilter();
  };

  const handleClickDropdown = () => {
    showDropdown(PRICE_PSEUDO_FACET_ID);
  };

  const selectedDropdownClass =
    selectedDropdown === PRICE_PSEUDO_FACET_ID ? style.selectedDropdown : null;

  const selectedDropdownIcon =
    selectedDropdown === PRICE_PSEUDO_FACET_ID ? "Up" : "Down";

  const numberizedPrice = (price) =>
    price === null || isNaN(price) ? "" : price;

  const clearPriceButton =
    isNaN(max_price_input) && isNaN(min_price_input) ? null : (
      <div className={style.clearPriceFilter} onClick={handleClearPrice}>
        Clear all
      </div>
    );

  return isMobile ? (
    <div className={mobileStyle.filterWrapper}>
      Price
      <div className={`${mobileStyle.pricefilterContainer}`}>
        <div className={mobileStyle.priceContainer}>
          <input
            className={mobileStyle.priceInput}
            placeholder="Min"
            id="minPriceValue"
            value={numberizedPrice(min_price_input)}
            onChange={handleChange}
          />
        </div>
        <div className={mobileStyle.priceContainer}>
          <input
            className={mobileStyle.priceInput}
            placeholder="Max"
            id="maxPriceValue"
            value={numberizedPrice(max_price_input)}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  ) : (
    <div className={style.filterWrapper} tabIndex="0">
      <div className={style.filterTitle} onClick={handleClickDropdown}>
        Price
        <img
          className={style.dropdownIcon}
          src={`https://cdn-s3.touchofmodern.com/images/icons/icon_filter${selectedDropdownIcon}Arrow%402x.png`}
          alt="filterArrow"
        />
      </div>
      <div
        className={`${style.filterDropdown} ${style.priceDropdown} ${selectedDropdownClass}`}
      >
        <div className={style.priceContainer}>
          <input
            className={style.priceInput}
            id="minPriceValue"
            value={numberizedPrice(min_price_input)}
            onChange={handleChange}
            placeholder="Min"
          />
        </div>
        <div className={style.priceContainer}>
          <input
            className={style.priceInput}
            id="maxPriceValue"
            value={numberizedPrice(max_price_input)}
            onChange={handleChange}
            placeholder="Max"
          />
        </div>
        <div className={style.setPriceContainer}>
          <button
            className={`${style.setPrice} btn btn-primary`}
            onClick={handleSetPrice}
          >
            Set price
          </button>
          {clearPriceButton}
        </div>
      </div>
    </div>
  );
};

PriceFilter.propTypes = {
  maxPrice: PropTypes.number.isRequired,
  minPrice: PropTypes.number.isRequired,
  min_price_input: PropTypes.number.isRequired,
  max_price_input: PropTypes.number.isRequired,
  selectedDropdown: PropTypes.number.isRequired,
  showDropdown: PropTypes.func.isRequired,
  handlePriceFilterClick: PropTypes.func.isRequired,
  handlePriceFilterInput: PropTypes.func.isRequired,
  clearPriceFilter: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default PriceFilter;
